import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // Import your existing firebase config

const LoginForm = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [checking, setChecking] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Check if already logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isAdminLoggedIn") === "true";
    if (isLoggedIn) {
      navigate("/admin", { replace: true });
    } else {
      setChecking(false);
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validate = () => {
    if (!formData.username) {
      toast.error("Username is required");
      return false;
    }
    if (!formData.password) {
      toast.error("Password is required");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();

    if (!validate()) return;
    
    setLoading(true);

    try {
      // Query Firebase for admin with matching username AND password
      const adminsRef = collection(db, "admins");
      const q = query(
        adminsRef, 
        where("username", "==", formData.username),
        where("password", "==", formData.password)
      );
      
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // Login successful
        localStorage.setItem("isAdminLoggedIn", "true");
        toast.success("Login successful!");
        setTimeout(() => navigate("/admin", { replace: true }), 1000);
      } else {
        toast.error("Invalid username or password");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Don't show form if checking login status
  if (checking) return null;

  return (
    <div
      className="Login-section contact-section padding-container"
      style={{ background: "white", position: "relative" }}
    >
      <div className="page-wrapper">
        <div className="contact-bg">
          <div className="contact-us-form">
            <div className="contact-text">
              <h1>LOGIN</h1>
              <p>Login to access your admin account</p>
            </div>

            <div className="contact-form">
              <h1>Login</h1>
              <form className="form-data" onSubmit={handleSubmit}>
                <div className="form-username">
                  <label htmlFor="username">Username</label>
                  <input
                    type="text"
                    name="username"
                    id="username"
                    value={formData.username}
                    onChange={handleChange}
                    disabled={loading}
                  />
                </div>

                <div className="form-phone password">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    value={formData.password}
                    onChange={handleChange}
                    disabled={loading}
                  />
                </div>

                <button type="submit" className="form-submit" disabled={loading}>
                  {loading ? "Logging in..." : "Login"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;